module.exports = __webpack_public_path__ + "static/media/features-ic-03.34a8b994.svg";